/**
 * PIN strength check — must mirror `_is_weak_pin` in
 * `backend/app/routers/staff_router.py` so the UX matches what the
 * server will accept.
 *
 * Rules:
 *   - Exactly 5 digits.
 *   - Not all the same digit.
 *   - Not a strictly ascending or descending run of consecutive digits.
 *
 * Returns a string describing the problem, or `null` if the PIN is strong.
 */
export const PIN_LENGTH = 5;

export function checkPinStrength(pin) {
  if (!pin || !/^\d+$/.test(pin) || pin.length !== PIN_LENGTH) {
    return 'PIN must be exactly 5 digits.';
  }
  const digits = pin.split('').map((c) => parseInt(c, 10));
  if (new Set(digits).size === 1) {
    return 'PIN cannot be the same digit repeated.';
  }
  const asc = digits.every((d, i) => i === 0 || d - digits[i - 1] === 1);
  const desc = digits.every((d, i) => i === 0 || d - digits[i - 1] === -1);
  if (asc || desc) {
    return 'PIN cannot be a sequence of consecutive numbers — use scattered digits.';
  }
  return null;
}
